import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';
import { FpLoggerNoiseSpreadChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread-chart.service';
import { FpLoggerNoiseSpreadConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread-connect.service';
import { FpLoggerNoiseSpreadExportService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread-export.service';
import { FpLoggerNoiseSpreadStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread/fp-logger-noise-spread.store';

export function fpLoggerNoiseSpreadProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseSpreadChartService,
    FpLoggerNoiseSpreadExportService,
    FpLoggerNoiseSpreadStore,
    FpLoggerNoiseSpreadConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseSpreadConnectService,
      multi: true,
    },
  ];
}
